var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute"}},[_c('ApplicationContext',{ref:"context",attrs:{"application":_vm.application,"workspace":_vm.workspace},scopedSlots:_vm._u([{key:"additional-context-items",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }